import { API, graphqlOperation } from 'aws-amplify';

const addSurveyMutation = `
  mutation($companyId: String!, $adminId: String!) {
    addSurvey(
      companyId: $companyId,
      adminId: $adminId,
    ) {
      id
    }
  }
`;

const addSurveyQuestionMutation = `
  mutation($companyId: String!, $surveyId: String!, $body: String!) {
    addSurveyQuestion(
      companyId: $companyId,
      surveyId: $surveyId,
      body: $body
    ) {
      id
    }
  }
`;

export function addSurveyQuestion({ COMPANY_ID, SURVEY_ID, BODY }) {
  return API.graphql(
    graphqlOperation(addSurveyQuestionMutation, {
      companyId: COMPANY_ID,
      surveyId: SURVEY_ID,
      body: BODY,
    })
  );
}

export function addSurvey({ COMPANY_ID, ADMIN_ID }) {
  return API.graphql(
    graphqlOperation(addSurveyMutation, {
      companyId: COMPANY_ID,
      adminId: ADMIN_ID,
    })
  );
}